import { styled } from '@mui/material';

import { usePreviewHighlight } from '../../hooks';
import { PreviewHighlight, PreviewHighlightLevel } from '../../types';

const getHighlightColor = (level: PreviewHighlightLevel) => {
  switch (level) {
    case 'ERROR':
      return 'var(--error-error-icon-primary-color)';
    case 'WARNING':
      return 'var(--warning-warning-icon-primary-color)';
    case 'INFO':
      return 'var(--info-info-icon-primary-color)';
  }
};

const StyledHighlightOverlayContainer = styled('div')({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  zIndex: 2,
});

const StyledHighlightOverlay = styled('div')<{
  highlight: NonNullable<PreviewHighlight>;
  referenceWidth: number;
  referenceHeight: number;
  color: string;
}>(({ highlight, referenceWidth, referenceHeight, color }) => ({
  position: 'absolute',
  left: `${(highlight.rect.x / referenceWidth) * 100}%`,
  top: `${(highlight.rect.y / referenceHeight) * 100}%`,
  width: `${(highlight.rect.width / referenceWidth) * 100}%`,
  height: `${(highlight.rect.height / referenceHeight) * 100}%`,
  border: `2px solid ${color}`,
  background: `color-mix(in srgb, ${color} 50%, transparent)`,
  borderRadius: 2,
  padding: 4,
  boxSizing: 'content-box',
  transform: 'translate(-6px, -6px)',
}));

export const PreviewHighlightOverlay = () => {
  const { highlight, viewportWidth, viewportHeight } = usePreviewHighlight();

  const referenceWidth = viewportWidth;
  const referenceHeight = viewportHeight;

  if (!highlight || !referenceWidth || !referenceHeight) {
    return null;
  }

  const color = getHighlightColor(highlight.level);

  return (
    <StyledHighlightOverlayContainer>
      <StyledHighlightOverlay
        highlight={highlight}
        referenceWidth={referenceWidth}
        referenceHeight={referenceHeight}
        color={color}
      />
    </StyledHighlightOverlayContainer>
  );
};
